import { apiCall } from './gqlClient';

const GETCLASSES_QUERY = `
  query getClasses($serviceId: Int!) {
    getClasses(serviceId: $serviceId)
    {
      id
			providerId
			serviceId
			name
			description
			startTime
			endTime
			duration
			capacity
			minimumCapacity
			price
			model
			sessionLimit
			active
			orderIndex
			sessionsCounter
			entityType
			locationType
			customerId
			preparationTime
			credits
      ...fragments
    }
  }`;

export const getClassesApiCall = async ({serviceId}, fragments = null) => apiCall({ query: GETCLASSES_QUERY, variables: {serviceId}, fragments });

const GETPUBLICCLASSES_QUERY = `
  query getPublicClasses($serviceId: Int!) {
    getPublicClasses(serviceId: $serviceId)
    {
      id
			providerId
			serviceId
			name
			description
			startTime
			endTime
			duration
			capacity
			minimumCapacity
			price
			model
			sessionLimit
			active
			orderIndex
			sessionsCounter
			entityType
			locationType
			customerId
			preparationTime
			credits
      ...fragments
    }
  }`;

export const getPublicClassesApiCall = async ({serviceId}, fragments = null) => apiCall({ query: GETPUBLICCLASSES_QUERY, variables: {serviceId}, fragments });

const GETPROVIDERCLASSES_QUERY = `
  query getProviderClasses($serviceId: Int!) {
    getProviderClasses(serviceId: $serviceId)
    {
      id
			providerId
			serviceId
			name
			description
			startTime
			endTime
			duration
			capacity
			minimumCapacity
			price
			model
			sessionLimit
			active
			orderIndex
			sessionsCounter
			entityType
			locationType
			customerId
			preparationTime
			credits
      ...fragments
    }
  }`;

export const getProviderClassesApiCall = async ({serviceId}, fragments = null) => apiCall({ query: GETPROVIDERCLASSES_QUERY, variables: {serviceId}, fragments });

const GETCLASSESFORBOOKING_QUERY = `
  query getClassesForBooking($providerId: Int) {
    getClassesForBooking(providerId: $providerId)
    {
      id
			name
			serviceType
			isAlwaysAvailable
      ...fragments
    }
  }`;

export const getClassesForBookingApiCall = async ({providerId}, fragments = null) => apiCall({ query: GETCLASSESFORBOOKING_QUERY, variables: {providerId}, fragments });

const GETPROVIDERALLCLASSES_QUERY = `
  query getProviderAllClasses($serviceId: Int!) {
    getProviderAllClasses(serviceId: $serviceId)
    {
      id
			providerId
			serviceId
			name
			description
			startTime
			endTime
			duration
			capacity
			minimumCapacity
			price
			model
			sessionLimit
			active
			orderIndex
			sessionsCounter
			entityType
			locationType
			customerId
			preparationTime
			credits
      ...fragments
    }
  }`;

export const getProviderAllClassesApiCall = async ({serviceId}, fragments = null) => apiCall({ query: GETPROVIDERALLCLASSES_QUERY, variables: {serviceId}, fragments });

const GETBUSINESSCLASSDETAILS_QUERY = `
  query getBusinessClassDetails($id: Int!) {
    getBusinessClassDetails(id: $id)
    {
      id
			providerId
			serviceId
			name
			description
			startTime
			endTime
			duration
			capacity
			minimumCapacity
			price
			model
			sessionLimit
			active
			orderIndex
			sessionsCounter
			entityType
			locationType
			customerId
			preparationTime
			credits
      ...fragments
    }
  }`;

export const getBusinessClassDetailsApiCall = async ({id}, fragments = null) => apiCall({ query: GETBUSINESSCLASSDETAILS_QUERY, variables: {id}, fragments });

const GETCLASSDETAILS_QUERY = `
  query getClassDetails($id: Int!) {
    getClassDetails(id: $id)
    {
      id
			providerId
			serviceId
			name
			description
			startTime
			endTime
			duration
			capacity
			minimumCapacity
			price
			model
			sessionLimit
			active
			orderIndex
			sessionsCounter
			entityType
			locationType
			customerId
			preparationTime
			credits
      ...fragments
    }
  }`;

export const getClassDetailsApiCall = async ({id}, fragments = null) => apiCall({ query: GETCLASSDETAILS_QUERY, variables: {id}, fragments });

const GETCLASSWEEKSCHEDULE_QUERY = `
  query getClassWeekSchedule($classId: Int!) {
    getClassWeekSchedule(classId: $classId)
    {
      classId
      ...fragments
    }
  }`;

export const getClassWeekScheduleApiCall = async ({classId}, fragments = null) => apiCall({ query: GETCLASSWEEKSCHEDULE_QUERY, variables: {classId}, fragments });

const GETBOOKABLECLASSES_QUERY = `
  query getBookableClasses {
    getBookableClasses
  }`;

export const getBookableClassesApiCall = async () => apiCall({ query: GETBOOKABLECLASSES_QUERY, variables: {}});

const DELETECLASS_QUERY = `
  mutation deleteClass($id: Int!) {
    deleteClass(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const deleteClassApiCall = async ({id}, fragments = null) => apiCall({ query: DELETECLASS_QUERY, variables: {id}, fragments });

const RESTORECLASS_QUERY = `
  mutation restoreClass($id: Int!) {
    restoreClass(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const restoreClassApiCall = async ({id}, fragments = null) => apiCall({ query: RESTORECLASS_QUERY, variables: {id}, fragments });

const DELETEINACTIVESESSIONS_QUERY = `
  mutation deleteInactiveSessions($classId: Int!) {
    deleteInactiveSessions(classId: $classId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const deleteInactiveSessionsApiCall = async ({classId}, fragments = null) => apiCall({ query: DELETEINACTIVESESSIONS_QUERY, variables: {classId}, fragments });

const SAVECLASS_QUERY = `
  mutation saveClass($request: GyClassCreateInput!) {
    saveClass(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const saveClassApiCall = async ({request}, fragments = null) => apiCall({ query: SAVECLASS_QUERY, variables: {request}, fragments });

const SAVECOURSEWITHCLASS_QUERY = `
  mutation saveCourseWithClass($request: ServicePlusSubServiceCreateInput!) {
    saveCourseWithClass(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const saveCourseWithClassApiCall = async ({request}, fragments = null) => apiCall({ query: SAVECOURSEWITHCLASS_QUERY, variables: {request}, fragments });

const TOGGLECLASSSTATUS_QUERY = `
  mutation toggleClassStatus($id: Int!, $isActive: Boolean!, $serviceId: Int!) {
    toggleClassStatus(id: $id, isActive: $isActive, serviceId: $serviceId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const toggleClassStatusApiCall = async ({id, isActive, serviceId}, fragments = null) => apiCall({ query: TOGGLECLASSSTATUS_QUERY, variables: {id, isActive, serviceId}, fragments });

const REORDERCLASSES_QUERY = `
  mutation reorderClasses($serviceId: Int!, $oldPosition: Int!, $newPosition: Int!) {
    reorderClasses(serviceId: $serviceId, oldPosition: $oldPosition, newPosition: $newPosition)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const reorderClassesApiCall = async ({serviceId, oldPosition, newPosition}, fragments = null) => apiCall({ query: REORDERCLASSES_QUERY, variables: {serviceId, oldPosition, newPosition}, fragments });

const SAVECLASSWEEKSCHEDULE_QUERY = `
  mutation saveClassWeekSchedule($classId: Int!, $schedule: [ClassWeekScheduleInput]!) {
    saveClassWeekSchedule(classId: $classId, schedule: $schedule)
  }`;

export const saveClassWeekScheduleApiCall = async ({classId, schedule}, ) => apiCall({ query: SAVECLASSWEEKSCHEDULE_QUERY, variables: {classId, schedule}});
